const dictionaries = {
  state: {
    dictionaries: {},
  },
  mutations: {
    setDictionaries(state, val) {
      state.dictionaries = val
    },
  },
  actions: {},
  getters: {
    getDictionaries(state) {
      return state.dictionaries
    },
  },
}
export default dictionaries
